import JobsResult from '../JobsResult'
import SearchResultsStyles from '../SearchResults/SearchResults.css'
import { IJobItem } from '../../services/Jobs/@type'
import { useContext } from 'react'
import AppContext from '../../context/AppContext'
import Pagination from '../Paginate'
import { isMobile } from '../utils'
import JobListPlaceholder from '../JobItemPlaceholder'
import { Container } from '@microfrontends/react-components'
import { IJobSearch } from '../../services/models'
interface IProps {
	jobsData?: IJobSearch | null
	title?: string | null
	description?: string | null
	utm?: string
}
export default function JobsResultsContainer(props: IProps) {
	const { title, description, jobsData, utm } = props
	const { t } = useContext(AppContext)
	return (
		<SearchResultsStyles>
			<Container>
				<main className='main'>
					<div className='main__container'>
						<div className='header'>
							<h1 className='header__title'>{title ?? ''}</h1>

							<p className='header__des'>{description ?? ''}</p>
						</div>
						<div className='result'>
							<div className='result__count'>
								<span className='result__count-number'>
									{jobsData?.meta?.nbHits ?? 0}
								</span>
								<span>{t('opening jobs')}</span>
							</div>
							{jobsData?.data &&
							jobsData?.data?.length ===
								0 ? null : jobsData?.data &&
							  jobsData.data.length > 0 ? (
								<div className='result__wrap'>
									{jobsData.data.map((item, i) => {
										return (
											<JobsResult
												key={item?.jobId}
												job={item}
												utm={utm}
											/>
										)
									})}
								</div>
							) : (
								<div className='loading-job-list'>
									<JobListPlaceholder />
								</div>
							)}
						</div>
					</div>

					{jobsData?.data && jobsData.data.length > 0 ? (
						<Pagination
							nbPages={jobsData?.meta?.nbPages ?? 10}
							currentPage={jobsData?.meta?.page ?? 0}
							space={isMobile() ? 1 : 2}
						/>
					) : null}
				</main>
			</Container>
		</SearchResultsStyles>
	)
}
